import request from '@/services/axios'

// 会员权益对比
export const getEquity = (data: any) => {
  return request.post('/api/vip/equity-compare', data)
}

// 赠送子账户权益
export const setSubAccount = (data: any) => {
  return request.post('/api/vip/give-sub-account-equity', data)
}
